
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as homepageG0CAEMMmrzQm3nYTS42c4iFW7_SVupMGOHvkvViPuuoMeta } from "C:/GitHub/builder-cms-mfe/pages/homepage.vue?macro=true";
import { default as speelgoedErxOWyUeoY_45MopuakS9P__hIyjENh9sbOxVTohZ_l_0Meta } from "C:/GitHub/builder-cms-mfe/pages/speelgoed.vue?macro=true";
import { default as fabrikantenbvdRo9_8n7mpSWIZm_45Hee3dCsBNfO_hnWe9M1QXRn1oMeta } from "C:/GitHub/builder-cms-mfe/pages/fabrikanten.vue?macro=true";
export default [
  {
    name: "homepage",
    path: "/homepage",
    component: () => import("C:/GitHub/builder-cms-mfe/pages/homepage.vue")
  },
  {
    name: "speelgoed",
    path: "/speelgoed",
    component: () => import("C:/GitHub/builder-cms-mfe/pages/speelgoed.vue")
  },
  {
    name: "fabrikanten",
    path: "/fabrikanten",
    component: () => import("C:/GitHub/builder-cms-mfe/pages/fabrikanten.vue")
  }
]